<template>
    <div class="social-organic-instagram-grid mt-5">
        <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>
        <div v-if="!has_grid_data && !reloading" class="nodata-container p-5 text-center">
            <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
            <template v-if="!!missed_accounts && !errors">
                <div class="missed-accounts my-3">There are no accounts connected for Instagram. Either connect an account or change the metrics/remove this section in the builder.</div>
            </template>
            <div v-if="errors" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
            <div v-else class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
        </div>
        <template v-if="has_grid_data">
        <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
         <div v-if="!!missed_accounts" class="missed-accounts my-3">There are no accounts connected for Instagram. Either connect an account or change the metrics/remove this section in the builder.</div>
        <h4 class="section-name my-3 text-uppercase">{{soigData.name}}</h4>
        </template>
        <div v-if="has_grid_data" class="row justify-content-center">
            <div  class="col-12 col-md-7 d-flex flex-column justify-content-center mt-2">
                <div class="grid-wrap left flex-grow-1 d-flex flex-wrap pl-2 pr-0">
                    <h5 class="grid-title left-title text-center text-uppercase mb-5 mt-3">{{grid_name}}</h5>
                    <div v-for="el in grid" class="img-wrap"><img remote :src="el.media_url" class="grid-img" alt="Image is no longer available" /></div>
                </div>
            </div>
            <div v-if="has_high_data" class="col-12 col-md-5 d-flex flex-column justify-content-center mt-2">
                <div class="grid-wrap flex-grow-1 px-2">
                    <h5 class="grid-title right-title text-center text-uppercase my-3">{{highlight}}</h5>
                    <div class="comment-wrap top">
                        <div class="header-wrap text-center mb-3"><img :src="$store.state.app_url+'/images/social/instagram/header.png/'" /></div>
                        <img class="dots" :src="$store.state.app_url+'/images/social/dots.png'" />
                        <img class="client-logo" :src="$store.state.app_url+'/images/client_logos/'+most_impressions.client_logo" />
                        <span class="account-name">{{most_impressions.account_name}}<span class="date">{{most_impressions.date}} <img class="globe" :src="$store.state.app_url+'/images/social/globe.png'" /></span></span>
                    </div>
                    <div><img v-if="!noStory" remote :src="most_impressions.media_url" class="most-impressions" alt="No Image found" /><p v-if="noStory" class="alt-image">Story is no longer available</p></div>
                    <div class="metrics-box">
                        <p><span class="metric-name">Likes:</span><span class="metric-value">{{most_impressions.like_count}}</span></p>
                        <p><span class="metric-name">Impressions:</span><span class="metric-value">{{most_impressions.impressions}}</span></p>
                    </div>
                    <div class="socials d-flex justify-content-around mt-3">
                        <span><img :src="$store.state.app_url+'/images/social/instagram/like.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/instagram/comment.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/instagram/share.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/instagram/save.png'" /></span>
                    </div>
                    <div class="comment-wrap">
                        <span class="message mt-2" v-html="most_impressions.message">{{most_impressions.message}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'hasSkb', 'soigData'],
        created() {
            if(this.isBuilt){
                const has_extra_data = _.has(this.soigData, 'extra_data');
                const has_grid_option = has_extra_data ? _.has(this.soigData.extra_data, 'grid') : false;
                const has_selected_option = has_extra_data ? _.has(this.soigData.extra_data, 'selected') : false;
                this.grid_name = has_grid_option ? this.soigData.extra_data['grid'] : 'LATEST INSTAGRAM GRID';
                this.highlight = has_selected_option ? this.soigData.extra_data['selected'] : 'STORIES HIGHLIGHT';
                    event_bus.$on('current_dwm', () => {
                    this.current_dwm = this.$store.state.current_dwm;
                    event_bus.$emit('reloading', true);
                });
                this.fetchServerData();
            }
        },
        data() {
            return {
                grid:[],
                most_impressions:null,
                has_grid_data:null,
                has_high_data:null,
                missed_accounts:null,
                grid_name:null,
                highlight:null,
                noStory:false,
                errors:false,
                query:'',
                showQueries:    this.$store.state.showQueries,
                reloading:true
            }
        },
        mounted() {
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        methods: {
            fetchServerData(){
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.soigData.report_id,
                    'element_abbr':this.soigData.element_abbreviation,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.soigData.element_id,
                    'prefixed_element_id': this.soigData.report_element_id,
                    'element_name': this.soigData.name,
                    'client_id':this.soigData.client_id,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,
                };
                axios.post('/api/reporting/element', params).then((response) => {
                    this.query = response.data.query;
                    this.errors = response.data.errors;
                    this.has_grid_data = response.data.has_grid_data;
                    this.has_high_data = response.data.has_high_data;
                    this.grid = response.data.grid;
                    this.most_impressions = response.data.most_impressions;
                    this.missed_accounts = !response.data.accounts;
                    this.checkImages();
                    this.reloading = false;
                });
                this.reloading = false;
            },
            checkImages(){
                const vueInstance = this;
                $("img.most-impressions").off().bind("error",function(){
                    const $el = $(this);
                    vueInstance.story_visible = false;
                    $el.addClass('url-expired').parent().addClass('url-expired');
                    vueInstance.noStory = true;
                });
                $("img.grid-img").off().bind("error",function(){
                    const $el = $(this);
                    $el.removeAttr('src').attr('foo', '').removeAttr('foo');
                    $el.addClass('url-expired');
                });
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    .social-organic-instagram-grid{
        span.h-line{
            display:inline-block;
            border-top:0.3rem solid;
            border-bottom:0.3rem solid;
            border-radius:0.6rem;
            width:100%;
        }
        div.grid-wrap{
            position:relative;
            border-radius:2rem;
            border:0.2rem solid $light-blue;
            div.img-wrap{
                position:relative;
                width:33%;
            }
            &.left{
                div.img-wrap{
                    padding:0.8rem;
                }
            }
            img.grid-img{
                max-width:100%;
            }
            img.most-impressions{
                max-width:100%;
            }
            h5.grid-title{
                font-size:1.2vw;
                &.left-title{
                    width:100%;
                }
            }
            div.metrics-box{
                position:absolute;
                top:40%;
                right:0;
                padding:0.5rem 2rem;
                border-radius:1rem;
                font-size:1.2rem;
                background-color:white;
                box-shadow: 0.4rem 0.4rem 0.5rem #afafaf;
                z-index:9;
                p{
                    padding:0;
                    margin:0;
                    span.metric-name{
                        font-weight:bold;
                    }
                }
            }
            div.comment-wrap {
                font-family:Helvetica, Arial, sans-serif;
                position: relative;
                max-width: 100%;
                font-size: 1.4rem;
                &.top{
                    min-height:10rem;
                }
                span {
                    display: inline-block;
                    padding: 1rem;
                    &.account-name {
                        font-size: 1.2rem;
                        font-weight: bold;
                        position: relative;
                        span.date {
                            position: absolute;
                            width: 100%;
                            min-width: 16rem;
                            bottom: -2rem;
                            font-weight: normal;
                            left: 0;
                            img.globe {
                                max-width: 1rem;
                                margin-top: -0.2rem;
                            }
                        }
                    }
                    b.more {
                        paddind: 0;
                        font-size: 1.2rem;
                        color: $gray-dark;
                    }
                }
                img.client-logo {
                    max-width: 3rem;
                    margin-left: 1rem;
                    border: 0.1rem solid $gray;
                    border-radius: 50%;
                }
                img.dots {
                    position: absolute;
                    top: 0.8rem;
                    right: 0.5rem;
                    max-height: 0.4rem;
                }
                &.inst {
                    min-height: 10rem;
                    img.dots {
                        top: 4.2rem;
                    }
                }
                div.header-wrap{
                    width:100%;
                }
            }
        }
        div.url-expired{
            text-align:center;
            height:50%;
            padding-top:4rem;
            p.alt-image{
                font-size:2rem;
            }
        }
    }
</style>
